<script setup>
import { useLayout } from '@/layout/composables/layout';
import { useKundenbereichStore } from '@/stores/kundenbereichStore';
import { computed, provide, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import AppBreadcrumbs from './AppBreadcrumbs.vue';
import AppSidebar from './AppSidebar.vue';
import AppTopbar from './AppTopbar.vue';

// Kundenbereich-Store initialisieren
const kundenbereichStore = useKundenbereichStore();

// Kunden-Parameter aus der Route extrahieren und für Child-Komponenten bereitstellen
const route = useRoute();
const kunde = computed(() => route.params.kunde || null);
provide('kunde', kunde);
provide('kundenbereichStore', kundenbereichStore);

// Props definieren (auch wenn nicht verwendet, um Warnung zu vermeiden)
defineProps({
    kunde: {
        type: String,
        default: null
    }
});

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.staticMenuMobileActive,
        'layout-menu-collapsed': layoutState.menuCollapsed
    };
});

function bindOutsideClickListener() {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                layoutState.overlayMenuActive = false;
                layoutState.staticMenuMobileActive = false;
                layoutState.menuHoverActive = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
}

function unbindOutsideClickListener() {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
}

function isOutsideClicked(event) {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    if (!sidebarEl || !topbarEl) {
        return false;
    }

    return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
}
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <app-topbar></app-topbar>
        <app-sidebar></app-sidebar>
        <div class="layout-main-container">
            <div class="layout-main">
                <NutzungsbedingungenGate>
                    <div class="md:hidden mb-4 -ml-4 -mr-4">
                        <AppBreadcrumbs :seite-titel-aktualisieren="false" />
                    </div>
                    
                    <router-view></router-view>
                </NutzungsbedingungenGate>
            </div>
        </div>
        <div class="layout-mask animate-fadein"></div>
    </div>
    <Toast />
</template>
